<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>

        <app-navbar></app-navbar>
        <div class="container mt-5">
          <div class="row" style="margin-right: 0px;margin-left: 0px;">
            <div class="heading col-md-12">
              <vs-breadcrumb
                align="left"
                :items="
                  [
                    {title: 'You are here : '},
                    {
                      title: 'Dashboard',
                      url: '/#/dashboard/program-officer/todoList'
                    },
                    {
                      title: this.trainingTitle,
                      url: '/#/dashboard/program-officer/todoList'
                    },
                    {
                      title: 'Trainer`s Feedback',
                      active: true
                    }
                  ]
                    "
              ></vs-breadcrumb>
              <h3 class="text-secondary">Facilitator's Feedback</h3>
            </div>
          </div>
          <!-- <div class="col-sm-12 p-0 mb-4">
            <span style="font-weight:bold">
              Form Complete : 20%
              <vs-progress :percent="20" color="primary">primary</vs-progress>
            </span>
          </div>-->
          <!-- training title name section starts -->
          <div class="form-group form-row text-dark">
            <h6 class="sub-frm-title">Event Information</h6>
            <div class="row col-sm-12">
              <label class="col-sm-1 font-weight-bold">Title:</label>
              <div class="col-sm-11">{{trainingTitle}}</div>
            </div>
            <div class="row col-sm-12">
              <div class="row col-sm-12">
                <label
                  class="col-sm-2 font-weight-bold"
                  style="padding:0px 0px 0px 15px"
                >Start Date:</label>
                <p
                  class="col-sm-2"
                  style="padding:0px 0px 0px 15px"
                  v-if="startDate !=''"
                >{{startDate}}</p>

                <label class="col-sm-2 font-weight-bold p-0">End Date:</label>
                <p class="col-sm-4 p-0" v-if="endDate !=''">{{endDate}}</p>
              </div>
            </div>
          </div>
          <!-- training title name section ends -->

          <!-- training question selection section starts -->
          <div v-if="addTrainerFeedbackForm == true">
            <div class="row form-row text-dark">
              <h6 class="sub-frm-title">Add Feedback questions</h6>
              <div class="col-sm-12"></div>
              <div class="col-sm-6 mt-2">
                <label style="color: #07a7e19c !important;margin-bottom:0px;" for="no_of_question">
                  <b>Enter no. of question(s)</b>
                  <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                </label>

                <div class="mt-2">
                  <input
                    style="height: 34px !important;"
                    type="number"
                    v-model="no_of_question"
                    class="form-control"
                    placeholder="Enter no. of questions you want to add to trainer's feedback..."
                  />
                </div>
              </div>
              <!-- filters starts -->
              <div class="col-sm-6 mt-2">
                <label style="color: #07a7e19c !important;margin-bottom:0px;" for="no_of_question">
                  <b>Previous  Event</b>
                  <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                </label>
                <!-- <p style="margin-bottom:0px;" class="mt-1">
                  <b>Previous  Event</b>
                </p>-->
                <div class="mt-2">
                  <selectize
                    id="select-state"
                    v-model="previoustrainingSelected"
                    :settings="previoustrainingSettings"
                  >
                    <option
                      v-for="(item,index) in previousTrainingArr"
                      :key="index"
                      :value="item.id"
                    >{{item.title}}</option>
                  </selectize>
                </div>
              </div>
            </div>
            <div class="row">
              <!-- filters ends -->
              <!-- Repository Starts -->
              <div class="col-sm-6 mt-5" style="border: 1px dotted #07a7e14f;">
                <div class="mb-3 repository-title">Repository</div>
                <vs-tabs alignment="fixed">
                  <vs-tab label="MCQ's">
                    <!-- question 1 Starts -->
                    <b-card
                      class="mb-3"
                      v-for="(item,index) in allMcqsQuestionsArr"
                      v-bind:key="index"
                    >
                      <b-card-text>
                        <h6>
                          <strong>Q{{index+1}})</strong>
                          {{item[0].qtitle}}
                          <span></span>
                        </h6>
                      </b-card-text>
                      <div>
                        <b-badge
                          class="p-2 mr-1"
                          href="#"
                          variant="secondary"
                          v-if="item[0].qfrequency != null"
                        >F : {{item[0].qfrequency}}</b-badge>
                        <b-badge class="p-2 mr-1" href="#" variant="secondary" v-else>F : 0</b-badge>

                        <b-button
                          @click="moveMcqsQuestion(index,item[0].qid)"
                          style="float:right;"
                          href="#"
                          size="sm"
                          variant="primary"
                        >Add</b-button>
                      </div>
                    </b-card>
                    <!-- question 1 Ends -->
                  </vs-tab>

                  <vs-tab label="Descriptive">
                    <!-- question 1 Starts -->
                    <b-card
                      class="mb-3"
                      v-for="(item,index) in allDescQuestionsArr"
                      v-bind:key="index"
                    >
                      <b-card-text>
                        <h6>
                          <strong>Q{{index+1}})</strong>
                          {{item[0].qtitle}}
                          <span></span>
                        </h6>
                      </b-card-text>
                      <div>
                        <b-badge
                          class="p-2 mr-1"
                          href="#"
                          variant="secondary"
                          v-if="item[0].qfrequency != null"
                        >F : {{item[0].qfrequency}}</b-badge>
                        <b-badge class="p-2 mr-1" href="#" variant="secondary" v-else>F : 0</b-badge>

                        <b-button
                          @click="moveDescQuestion(index,item[0].qid)"
                          style="float:right;"
                          href="#"
                          size="sm"
                          variant="primary"
                        >Add</b-button>
                      </div>
                    </b-card>
                    <!-- question 1 Ends -->
                  </vs-tab>
                </vs-tabs>
                <!-- <div>
                <vs-pagination :total="40" v-model="currentx"></vs-pagination>
                </div>-->
              </div>
              <!-- Repository Ends -->

              <!-- Selected questions Starts -->
              <div class="col-sm-6 mt-5" style="border: 1px dotted #07a7e14f; border-left:none;">
                <div class="mb-3 ml-1 selected-title">Selected</div>
                <vs-tabs alignment="fixed">
                  <vs-tab label="MCQ's">
                    ({{this.selectedMcqsQuestionsArr.length}})
                    <!-- question 1 Starts -->
                    <b-card
                      class="mb-3"
                      v-for="(item,index) in selectedMcqsQuestionsArr"
                      v-bind:key="index"
                    >
                      <b-card-text>
                        <h6>
                          <strong>Q {{index+1}})</strong>
                          {{item[0].qtitle}}
                          <span></span>
                        </h6>
                      </b-card-text>
                      <div>
                        <b-badge
                          class="p-2 mr-1"
                          href="#"
                          variant="secondary"
                          v-if="item[0].qfrequency != null"
                        >F : {{item[0].qfrequency + 1}}</b-badge>
                        <b-badge class="p-2 mr-1" href="#" variant="secondary" v-else>F : 1</b-badge>

                        <b-button
                          variant="danger"
                          style="float:right;border:1px solid #f60404;"
                          class="m-1"
                          href="#"
                          size="sm"
                          @click="removeMcqsQuestion(index)"
                        >Remove</b-button>
                      </div>
                    </b-card>
                    <!-- question 1 Ends -->
                  </vs-tab>
                  <vs-tab label="Descriptive">
                    ({{this.selectedDescQuestionsArr.length}})
                    <!-- question 1 Starts -->
                    <b-card
                      class="mb-3"
                      v-for="(item,index) in selectedDescQuestionsArr"
                      v-bind:key="index"
                    >
                      <b-card-text>
                        <h6>
                          <strong>Q {{index+1}})</strong>
                          {{item[0].qtitle}}
                          <span></span>
                        </h6>
                      </b-card-text>
                      <div>
                        <b-badge
                          class="p-2 mr-1"
                          href="#"
                          variant="secondary"
                          v-if="item[0].qfrequency != null"
                        >F : {{item[0].qfrequency + 1}}</b-badge>
                        <b-badge class="p-2 mr-1" href="#" variant="secondary" v-else>F : 1</b-badge>

                        <b-button
                          variant="danger"
                          style="float:right;border:1px solid #f60404;"
                          class="m-1"
                          href="#"
                          size="sm"
                          @click="removeDescQuestion(index)"
                        >Remove</b-button>
                      </div>
                    </b-card>
                    <!-- question 1 Ends -->
                  </vs-tab>
                </vs-tabs>
                <div
                  class="mb-5"
                  v-if="this.selectedMcqsQuestionsArr.length > 0 | this.selectedDescQuestionsArr.length > 0"
                >
                  <b-button
                    variant="primary"
                    @click="submitForm()"
                    style="float:right;"
                    href="#"
                    size="sm"
                  >Submit</b-button>
                </div>

                <!-- <div>
                <vs-pagination :total="40" v-model="currentx2"></vs-pagination>
                </div>-->
              </div>
              <!-- Selected questions Ends -->
            </div>
          </div>
          <div v-else-if="existTrainerFeedbackForm == true">
            <h6 class="sub-frm-title">Facilitator's Feedback has been created for this training</h6>
            <!-- table starts -->
            <b-card class="mt-3">
              <div class="form-group">
                <div class="row">
                  <div class="col-sm-12 p-0">
                    <div class="table-responsive">
                      <div class="mb-1" style="float:right">
                        <b-button variant="outline-primary" class="mr-1" size="sm">Edit</b-button>
                        <b-button variant="outline-danger" class="mr-1" size="sm">Delete</b-button>
                      </div>
                      <table class="table">
                        <tr>
                          <th>Sr#</th>
                          <th>Question</th>
                          <th>Type</th>
                          <th>Added at</th>
                        </tr>
                        <tr v-for="(item,index) in trainerFeedbackShowArr" v-bind:key="index">
                          <td>{{index+1}}</td>
                          <td>{{item.question.title}}</td>
                          <td v-if="item.type == 'mcqs'">MCQ's</td>
                          <td v-else-if="item.type == 'descriptive'">Descriptive</td>
                          <td v-else>
                            <code>NULL</code>
                          </td>
                          <td>{{item.createdAt | formatDate}}</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </b-card>
          </div>
          <!-- training question selection section ends -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./subSidebar";
import axios from "axios";
import Selectize from "vue2-selectize";
export default {
  data: () => ({
    trainingDates: [],
    trainingId: "",
    trainingCode: "",
    trainingtitle: "",
    no_of_question: "",
    startDate: "",
    endDate: "",
    previousTrainingArr: [],
    previoustrainingSelected: "",
    previoustrainingSettings: {
      maxItems: 4,
      plugins: ["remove_button"]
    },

    isSidebar: false,
    allMcqsQuestionsArr: [],
    allDescQuestionsArr: [],
    filteredQuestionsArr: [],
    selectedMcqsQuestionsArr: [],
    selectedDescQuestionsArr: [],
    addTrainerFeedbackForm: true,
    existTrainerFeedbackForm: false,
    trainerFeedbackShowArr: []
  }),
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    this.trainingCode = this.$route.query.trainingId;
    this.openLoading();
    axios
      .get(
        process.env.VUE_APP_BASE_PATH +
          "/programOfficer/trainingsingle/get/" +
          this.trainingCode
     
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.trainingId = response.data.training.id;
        this.currentTraining();
        this.showPreviousTrainings();
        this.allQuestions();
        this.isExistTrainerFeedback();
        this.showTrainerFeedback();
      });
  },
  methods: {
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    toastSuccess(msg) {
      this.$bvToast.toast(msg, {
        title: "Success",
        autoHideDelay: 2000,
        variant: "success",
        solid: true
      });
    },
    toastError(msg) {
      this.$bvToast.toast(msg, {
        title: "Error",
        autoHideDelay: 2000,
        variant: "danger",
        solid: true
      });
    },
    // this will check if trainer feedback already created or not
    isExistTrainerFeedback: function isExistTrainerFeedback() {
      this.openLoading();
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/trainer-feedback/" +
            this.trainingId +
            "/check/get"
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response.data.success != "" && response.data.success != null) {
            this.addTrainerFeedbackForm = false;
            this.existTrainerFeedbackForm = true;
          } else {
            this.addTrainerFeedbackForm = true;
            this.existTrainerFeedbackForm = false;
          }
        });
    },
    // this will show trainer feedback which has been added
    showTrainerFeedback: function showTrainerFeedback() {
      this.openLoading();
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/program-officer/training/trainer-feedback/" +
            this.trainingId +
            "/show"
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.trainerFeedbackShowArr = response.data;
        });
    },
    // this will show current training of a program officer
    currentTraining: function currentTraining() {
      let userId = JSON.parse(localStorage.getItem("currentUser"));
      this.openLoading();
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/current-training/" +
            this.trainingId +
            "/" +
            userId.id +
            "/trainer-feedback/get"
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.trainingTitle = response.data.title;
          this.startDate = response.data.startdate;
          this.endDate = response.data.enddate;
        });
    },
    // this will show previous trainings
    showPreviousTrainings: function showPreviousTrainings() {
      this.openLoading();
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/previous-trainings/" +
            this.trainingId +
            "/trainer-feedback/get"
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.previousTrainingArr = response.data;
        });
    },
    // this will show all questions
    allQuestions: function allQuestions() {
      this.openLoading();
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/admin/all-questions/trainer-feedback/get"
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          response.data.forEach(element => {
            if (element[0].qtype == "checkbox") {
              this.allMcqsQuestionsArr.push(element);
            } else {
              this.allDescQuestionsArr.push(element);
            }
          });
        });
    },
    // this will show selected mcqs questions
    async moveMcqsQuestion(val, qid) {
      if (this.no_of_question != "" && this.no_of_question != 0) {
        if (
          this.selectedDescQuestionsArr.length +
            this.selectedMcqsQuestionsArr.length >=
          this.no_of_question
        ) {
          this.$toasted.global.errorMsg("Selected questions queue is full.");
          return false;
        } else {
          let checkValue = this.selectedMcqsQuestionsArr.some(function(value) {
            return value[0].qid == qid;
          });

          if (checkValue == true) {
            this.$toasted.global.errorMsg("Question was already moved.");
          } else {
            // this.moveScrollTo();
            this.$toasted.global.successMsg("Question moved successfully!");
            this.selectedMcqsQuestionsArr.push(this.allMcqsQuestionsArr[val]);
            this.allMcqsQuestionsArr.splice(val, 1);
          }
        }
      } else {
        this.$toasted.global.errorMsg("Enter no of questions you want to select.");
      }
    },
    // this will remove mcqs questions from selected queue
    removeMcqsQuestion(val) {
      this.allMcqsQuestionsArr.push(this.selectedMcqsQuestionsArr[val]);
      this.selectedMcqsQuestionsArr.splice(val, 1);
      this.$toasted.global.errorMsg("Question removed from MCQs selected!");
    },

    // this will show selected desc questions
    async moveDescQuestion(val, qid) {
      if (this.no_of_question != "" && this.no_of_question != 0) {
        if (
          this.selectedDescQuestionsArr.length +
            this.selectedMcqsQuestionsArr.length >=
          this.no_of_question
        ) {
          this.$toasted.global.errorMsg("Selected questions queue is full.");
          return false;
        } else {
          let checkValue = this.selectedDescQuestionsArr.some(function(value) {
            return value[0].qid == qid;
          });

          if (checkValue == true) {
            this.$toasted.global.errorMsg("Question was already moved to descriptive list.");
          } else {
            // this.moveScrollTo();
            this.$toasted.global.successMsg(
              "Question moved to descriptive list successfully!"
            );
            this.selectedDescQuestionsArr.push(this.allDescQuestionsArr[val]);
            this.allDescQuestionsArr.splice(val, 1);
          }
        }
      } else {
        this.$toasted.global.errorMsg("Enter no of questions you want to select.");
      }
    },
    // this will remove mcqs questions from selected queue
    removeDescQuestion(val) {
      this.allDescQuestionsArr.push(this.selectedDescQuestionsArr[val]);
      this.selectedDescQuestionsArr.splice(val, 1);
      this.$toasted.global.errorMsg("Question removed from Descriptive selected list!");
    },

    // This will submit trainees feedback form form
    submitForm() {
      if (
        this.no_of_question !=
        this.selectedMcqsQuestionsArr.length +
          this.selectedDescQuestionsArr.length
      ) {
        this.$toasted.global.errorMsg(
          "Please check that no. of question is equal to selected question."
        );
      } else {
        let userId = JSON.parse(localStorage.getItem("currentUser"));
        this.openLoading();
        axios
          .post(
            process.env.VUE_APP_BASE_PATH +
              "/admin/program-officer/trainer-feedback/add",
            {
              mcqsArr: this.selectedMcqsQuestionsArr,
              descArr: this.selectedDescQuestionsArr,
              training_id: this.trainingId,
              user_id: userId.id
            }
          )
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              // empty all varaibles
              this.allMcqsQuestionsArr = [];
              this.allDescQuestionsArr = [];
              this.selectedMcqsQuestionsArr = [];
              this.selectedDescQuestionsArr = [];
              this.addTrainerFeedbackForm = false;
              this.existTrainerFeedbackForm = true;
              // End empty all varaibles
              this.$toasted.global.successMsg(
                "Trainer Feedback has been created successfully."
              );
            } else {
              this.$toasted.global.errorMsg(
                "Error: Something went wrong while creating Trainer Feedback."
              );
            }
          });
      }
    }
    // End of methods
  },
  components: {
    Selectize,
    "app-navbar": Navbar,
    "app-sidebar": Sidebar
  },
  watch: {
    // this will check if no. of questions given in input is greater than questions selected in queue
    no_of_question() {
      if (
        this.selectedMcqsQuestionsArr.length > 0 &&
        this.selectedDescQuestionsArr.length > 0 &&
        this.no_of_question <
          (this.selectedMcqsQuestionsArr.length ||
            this.selectedDescQuestionsArr.length)
      ) {
        this.$toasted.global.errorMsg(
          "No. of questions in input, decreased from selected questions in queue."
        );
      } else if (
        (this.selectedMcqsQuestionsArr.length ||
          this.selectedDescQuestionsArr.length) > 0 &&
        this.no_of_question ==
          (this.selectedMcqsQuestionsArr.length ||
            this.selectedDescQuestionsArr.length)
      ) {
        return true;
      } else if (this.no_of_question <= 0) {
        this.$toasted.global.errorMsg("Number of question(s) must be greater than zero.");
      } else {
        this.$toasted.global.successMsg("Now you can move questions.");
      }
    }
  }
};
</script>

<style scoped>
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}
.b-list-group-item.opt-list-item {
  border: none !important;
}
.frm-title {
  text-align: center;
  padding: 10px;
  color: #009ad2;
  /* border-bottom: 2px solid #009ad2; */
}
.level-radios ul li {
  padding: 3px;
}
.p-2 {
  padding: 12px !important;
}
.repository-title {
  width: 142px;
  padding: 0px 5px;
  color: rgba(7, 167, 225, 0.61);
  background-color: #fff;
  font-size: 28px;
  margin-top: -25px;
}
.selected-title {
  width: 115px;
  padding: 0px 5px;
  color: rgba(7, 167, 225, 0.61);
  background-color: #fff;
  font-size: 28px;
  margin-top: -25px;
}
.crd-title {
  font-size: 20px;
}
</style>
<style >
.vs-slider {
  background-color: #c9ddff !important;
}
.con-content--item {
  padding: 0px !important;
}
</style>
